// These constants are evaluated at module load, which means they also run in
// Node when the landing page is prerendered (see scripts/prerender.mjs). No
// request is ever issued during a prerender, so falling back to the build-time
// env value there is enough — in the browser the behaviour is unchanged.
const isBrowser = typeof window !== 'undefined';

const getApiBaseUrl = () => {
  if (!isBrowser) {
    return import.meta.env.VITE_B2B_API_URL || 'http://localhost:3000';
  }

  const { hostname } = window.location;

  if (hostname === 'client-portal.thredtest.com') {
    return 'https://client-portal-api.thredtest.com';
  }

  if (
    hostname === 'client-portal.internal.thredup.com' ||
    hostname === 'client-portal.thredup.com'
  ) {
    return 'https://client-portal-api.thredup.com';
  }

  return import.meta.env.VITE_B2B_API_URL || 'http://localhost:3000';
};

const getAuthBaseUrl = () => {
  if (!isBrowser) {
    return getApiBaseUrl();
  }

  const { hostname } = window.location;

  if (hostname === 'client-portal.thredup.com') {
    return 'https://client-portal-auth.thredup.com';
  }

  return getApiBaseUrl();
};

export const API_BASE_URL = getApiBaseUrl();
export const AUTH_BASE_URL = getAuthBaseUrl();

export const API_ENDPOINTS = {
  AUTH_LOGIN: `${AUTH_BASE_URL}/auth/login`,
  AUTH_LOGOUT: `${AUTH_BASE_URL}/auth/logout`,
  AUTH_SWITCH_ORGANIZATION: `${AUTH_BASE_URL}/auth/switch-organization`
};
